// 세션 종료/로그아웃 공통 헬퍼.
// client.ts 와 tokenRefresh.ts 가 함께 사용하므로 별도 모듈로 분리해 순환 import 를 막는다.

export const SESSION_REPLACED_FLAG = 'auth_session_replaced';

export const clearSession = (): void => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('role');
};

export const redirectToLogin = (message: string): void => {
  if (window.location.pathname !== '/login') {
    sessionStorage.setItem('auth_redirect_message', message);
    window.location.href = '/login';
  }
};

// ISS-062 — 다른 위치 로그인으로 세션이 종료된 경우. refresh 로 복구 불가하므로
// 즉시 토큰 폐기 + 모달 플래그 후 /login 으로 이동한다.
export const handleSessionReplaced = (): void => {
  clearSession();
  sessionStorage.setItem(SESSION_REPLACED_FLAG, '1');
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};
